import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { createApiCall } from 'services'
import type { ITheme } from 'store/theme/types'

type UseGetCompanyStylesParams = {
  companyId?: string
}

type useGetCompanyStylesResponse = {
  styles: ITheme
}

const getCompanySettings = async (companyId: string): Promise<useGetCompanyStylesResponse> => {
  const response = await createApiCall({
    method: 'GET',
    url: `/companies/public/${companyId}/settings/style`,
  })

  return response.data as useGetCompanyStylesResponse
}

export const useGetCompanyStyles = (params: UseGetCompanyStylesParams): UseQueryResult<useGetCompanyStylesResponse, Error> => {
  const { companyId } = params

  return useQuery({
    queryKey: ['companyStyles', companyId],
    queryFn: () => getCompanySettings(companyId as string),
    enabled: !!companyId,
  })
}